import { Controller } from "@hotwired/stimulus"

// Soft scroll-reveal for marketing sections. Elements marked with
// [data-reveal] ship visible (no-JS and reduced-motion visitors see
// everything); when motion is allowed this arms the hidden state and
// reveals each element as it scrolls into view, staggering elements
// that arrive in the same observer batch.
export default class extends Controller {
  connect() {
    this.items = [...this.element.querySelectorAll("[data-reveal]")]
    if (!this.items.length) return
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.element.classList.add("reveal-armed")
    this.observer = new IntersectionObserver((entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach((entry, index) => {
          entry.target.style.transitionDelay = `${index * 90}ms`
          entry.target.classList.add("is-revealed")
          this.observer.unobserve(entry.target)
        })
    }, { threshold: 0.15, rootMargin: "0px 0px -5% 0px" })

    this.items.forEach((item) => this.observer.observe(item))
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.classList.remove("reveal-armed")
  }
}
